'use strict';

var entryFactory = require('../../../../factory/EntryFactory');

/**
 * Create an entry to modify the name of an an element.
 *
 * @param  {djs.model.Base} element
 * @param  {Object} options
 * @param  {string} options.id the id of the entry
 * @param  {string} options.label the label of the entry
 *
 * @return {Array<Object>} return an array containing
 *                         the entry to modify the name
 */
module.exports = function(element, options, translate) {

  options = options || {};
  var id = options.id || 'taskType',
      label = options.label || translate('Task Type'),
      modelProperty = options.modelProperty || 'taskType';

  var taskTypeEntry = entryFactory.extensionModelTextBox({
    id: id,
    label: label,
    modelProperty: modelProperty
  });

  return [ taskTypeEntry ];

};
